module.exports = __webpack_public_path__ + "static/media/square-fb-icon.6ac6237d.svg";